import axios from 'axios'
import { toast } from 'react-toastify';
import requestConfigs, { getPath, getRequestRequirement } from './requestConfig'
const paseUrl = process.env.REACT_APP_API_ENDPOINT + requestConfigs.prefix + requestConfigs.varsion;
let use_T = null




axios.defaults.headers.Accept = 'application/json'
axios.defaults.headers.common['Accept-Language'] = localStorage.getItem('i18nextLng')
let requirement = {};

axios.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem('oopToken')
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`
    }

    return config
  },
  (err) =>
    Promise.reject(err),
)
axios.defaults.withCredentials = true
axios.interceptors.response.use(
  response => response,
  (err) => {

    if (err.response?.status === 401) {
      localStorage.removeItem("oopToken")

      window.location = "/login"



    }
    if (requirement?.action?.enable_message) {

      toast.error(err.response && err.response?.data && err.response?.data?.error_description ? err.response?.data?.error_description : "بروز خطای نامشخص")

    }
    return { ...err, option: requirement.action }
  },
)

export default axios

export const apiRequest = async (path, params = {}, pathParams = '', isCoreApi) => {

  if (!isCoreApi) {
    axios.defaults.baseURL = paseUrl

  } else {
    axios.defaults.baseURL = process.env.REACT_APP_CORE_API_ENDPOINT;

  }

  requirement = getRequestRequirement(path);
  switch (requirement.action.method) {
    case 'post':
      {
        const response = await axios.post(requirement.path + pathParams, params)

        if (response.status === 200 && requirement.action.enable_message) {
          toast.success(use_T(requirement.action.successMessage))
          return { ...response, option: requirement.action }

        } else if (response.status === 200) {
          return { ...response, option: requirement.action }

        }
        else {
          throw { ...response, option: requirement.action }
        }
      }

    case 'get':
      {

        const response = await axios.get(requirement.path + pathParams, params)
        if ((response.status === 200 || response.status === 204) && requirement.action.enable_message) {
          toast.success(requirement.action.successMessage)
          return { ...response, option: requirement.action }

        } else if (response.status === 200 || response.status === 204) {
          return { ...response, option: requirement.action }

        }
        else {
          throw { ...response, option: requirement.action }
        }
      }
    case 'put':
      {
        const response = await axios.put(requirement.path + pathParams, params)
        if ((response.status === 200 || response.status === 204) && requirement.action.enable_message) {
          toast.success(requirement.action.successMessage)
          return { ...response, option: requirement.action }

        } else if (response.status === 200 || response.status === 204) {
          return { ...response, option: requirement.action }

        }
        else {
          throw { ...response, option: requirement.action }
        }
      }
    case 'delete':
      {
        const response = await axios.delete(requirement.path + pathParams)
        if ((response.status === 200 || response.status === 204) && requirement.action.enable_message) {
          toast.success(requirement.action.successMessage)
          return { ...response, option: requirement.action }

        } else if (response.status === 200 || response.status === 204) {
          return { ...response, option: requirement.action }

        }
        else {
          throw { ...response, option: requirement.action }
        }
      }
    default:
      throw "Method not found";
  }
}

export const initialUseTranslation = (_use_T) => {
  use_T = _use_T
}

export const socketAddress = process.env.REACT_APP_CORE_API_ENDPOINT
